/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ProfessorsReportDTO
 */
export interface ProfessorsReportDTO {
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	professorName?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	facultyName?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	departmentName?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	teachingGrade?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	email?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r1?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r2?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r3?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r4?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r5?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r6?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r7?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r8?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r9?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r10?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r11?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r12?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r13?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r14?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r15?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r16?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r17?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r18?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r19?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r20?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r21?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r22?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r23?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r24?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r25?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r26?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r27?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r28?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r29?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r30?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r31?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r32?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r33?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r34?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r35?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r36?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r37?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r38?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r39?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r40?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r41?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r42?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r43?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ProfessorsReportDTO
	 */
	r44?: string | null;
}

export function ProfessorsReportDTOFromJSON(json: any): ProfessorsReportDTO {
	return ProfessorsReportDTOFromJSONTyped(json, false);
}

export function ProfessorsReportDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ProfessorsReportDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		professorName: !exists(json, "professorName")
			? undefined
			: json["professorName"],
		facultyName: !exists(json, "facultyName") ? undefined : json["facultyName"],
		departmentName: !exists(json, "departmentName")
			? undefined
			: json["departmentName"],
		teachingGrade: !exists(json, "teachingGrade")
			? undefined
			: json["teachingGrade"],
		email: !exists(json, "email") ? undefined : json["email"],
		r1: !exists(json, "r1") ? undefined : json["r1"],
		r2: !exists(json, "r2") ? undefined : json["r2"],
		r3: !exists(json, "r3") ? undefined : json["r3"],
		r4: !exists(json, "r4") ? undefined : json["r4"],
		r5: !exists(json, "r5") ? undefined : json["r5"],
		r6: !exists(json, "r6") ? undefined : json["r6"],
		r7: !exists(json, "r7") ? undefined : json["r7"],
		r8: !exists(json, "r8") ? undefined : json["r8"],
		r9: !exists(json, "r9") ? undefined : json["r9"],
		r10: !exists(json, "r10") ? undefined : json["r10"],
		r11: !exists(json, "r11") ? undefined : json["r11"],
		r12: !exists(json, "r12") ? undefined : json["r12"],
		r13: !exists(json, "r13") ? undefined : json["r13"],
		r14: !exists(json, "r14") ? undefined : json["r14"],
		r15: !exists(json, "r15") ? undefined : json["r15"],
		r16: !exists(json, "r16") ? undefined : json["r16"],
		r17: !exists(json, "r17") ? undefined : json["r17"],
		r18: !exists(json, "r18") ? undefined : json["r18"],
		r19: !exists(json, "r19") ? undefined : json["r19"],
		r20: !exists(json, "r20") ? undefined : json["r20"],
		r21: !exists(json, "r21") ? undefined : json["r21"],
		r22: !exists(json, "r22") ? undefined : json["r22"],
		r23: !exists(json, "r23") ? undefined : json["r23"],
		r24: !exists(json, "r24") ? undefined : json["r24"],
		r25: !exists(json, "r25") ? undefined : json["r25"],
		r26: !exists(json, "r26") ? undefined : json["r26"],
		r27: !exists(json, "r27") ? undefined : json["r27"],
		r28: !exists(json, "r28") ? undefined : json["r28"],
		r29: !exists(json, "r29") ? undefined : json["r29"],
		r30: !exists(json, "r30") ? undefined : json["r30"],
		r31: !exists(json, "r31") ? undefined : json["r31"],
		r32: !exists(json, "r32") ? undefined : json["r32"],
		r33: !exists(json, "r33") ? undefined : json["r33"],
		r34: !exists(json, "r34") ? undefined : json["r34"],
		r35: !exists(json, "r35") ? undefined : json["r35"],
		r36: !exists(json, "r36") ? undefined : json["r36"],
		r37: !exists(json, "r37") ? undefined : json["r37"],
		r38: !exists(json, "r38") ? undefined : json["r38"],
		r39: !exists(json, "r39") ? undefined : json["r39"],
		r40: !exists(json, "r40") ? undefined : json["r40"],
		r41: !exists(json, "r41") ? undefined : json["r41"],
		r42: !exists(json, "r42") ? undefined : json["r42"],
		r43: !exists(json, "r43") ? undefined : json["r43"],
		r44: !exists(json, "r44") ? undefined : json["r44"],
	};
}

export function ProfessorsReportDTOToJSON(
	value?: ProfessorsReportDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		professorName: value.professorName,
		facultyName: value.facultyName,
		departmentName: value.departmentName,
		teachingGrade: value.teachingGrade,
		email: value.email,
		r1: value.r1,
		r2: value.r2,
		r3: value.r3,
		r4: value.r4,
		r5: value.r5,
		r6: value.r6,
		r7: value.r7,
		r8: value.r8,
		r9: value.r9,
		r10: value.r10,
		r11: value.r11,
		r12: value.r12,
		r13: value.r13,
		r14: value.r14,
		r15: value.r15,
		r16: value.r16,
		r17: value.r17,
		r18: value.r18,
		r19: value.r19,
		r20: value.r20,
		r21: value.r21,
		r22: value.r22,
		r23: value.r23,
		r24: value.r24,
		r25: value.r25,
		r26: value.r26,
		r27: value.r27,
		r28: value.r28,
		r29: value.r29,
		r30: value.r30,
		r31: value.r31,
		r32: value.r32,
		r33: value.r33,
		r34: value.r34,
		r35: value.r35,
		r36: value.r36,
		r37: value.r37,
		r38: value.r38,
		r39: value.r39,
		r40: value.r40,
		r41: value.r41,
		r42: value.r42,
		r43: value.r43,
		r44: value.r44,
	};
}
